import React, { memo } from 'react';
import { getCountryCodeFromPhone, getFlagIcon } from '../../../services/countryService';
import { getClientDisplayName, getClientPhone } from './customerListUtils';

const CustomerRowMC = memo(({
  client,
  isChecking,
  isBusy,
  onCall,
  callLabel
}) => {
  const countryCode = getCountryCodeFromPhone(client.phone_with_country_code, client.phone);
  const callDisabled = isChecking || isBusy;
  const buttonClassName = `tw-flex tw-items-center tw-justify-center tw-px-3 tw-py-1.5 tw-text-white tw-text-xs tw-font-medium tw-rounded-full tw-transition-colors ${callDisabled ? 'tw-bg-gray-400' : 'tw-bg-green-400 hover:tw-bg-green-500'}`;

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-4 tw-border-b tw-border-gray-100 hover:tw-bg-gray-50">
      <div className="tw-flex tw-flex-col">
        <span className="tw-text-sm tw-font-medium tw-text-gray-900">
          {getClientDisplayName(client)}
        </span>
        {client.email && (
          <span className="tw-text-xs tw-text-gray-500">{client.email}</span>
        )}
        <div className="tw-flex tw-items-center tw-mt-1 tw-gap-1">
          {countryCode && getFlagIcon(countryCode)}
          <span className="tw-text-xs tw-text-gray-500">
            {getClientPhone(client)}
          </span>
        </div>
      </div>

      <button
        type="button"
        onClick={() => onCall(client)}
        disabled={callDisabled}
        className={buttonClassName}
      >
        {isChecking ? (
          <div className="tw-animate-spin tw-mr-1 tw-h-3 tw-w-3 tw-border-b-2 tw-border-white tw-rounded-full"></div>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="tw-h-3 tw-w-3 tw-mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
        )}
        {callLabel}
      </button>
    </div>
  );
});

CustomerRowMC.displayName = 'CustomerRowMC';

export default CustomerRowMC;
